import { Injectable } from '@angular/core';
import {OrderModel} from "../../models/orders/order.model";
import {CurrencyModel} from "../../models/menu/currency-model";
@Injectable({
  providedIn: 'root',
})
export class OrderDataTransferService {
  order: OrderModel;
  currency: CurrencyModel;
  orderBillNumber: string;

  public resetData(){
    this.order = new OrderModel();
    this.currency = new CurrencyModel();
    this.orderBillNumber = '';
  }
}
